import React from "react";
import NewsSlider from "../NewsSlider/NewsSlider";

import Location from "../../assets/Icons/map.svg";
import Message from "../../assets/Icons/message.svg";
import Calendar from "../../assets/Icons/calendar.svg";
import Time from "../../assets/Icons/time.svg";

import { Link } from "react-router-dom";
import FrontPageSlider from "../ImageSlider/FrontPageSlider";

import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

function FrontPage() {
	const images = [
		"https://res.cloudinary.com/atlasendurhaefing/image/upload/v1692290191/atlas2.0/banners/AtlasBanner03_kbhzqq.jpg",
		"https://res.cloudinary.com/atlasendurhaefing/image/upload/v1692290191/atlas2.0/banners/AtlasBanner02_n7ehrb.jpg",
		"https://res.cloudinary.com/atlasendurhaefing/image/upload/v1692291808/atlas2.0/banners/AtlasBanner01_i7dk9u.jpg",
	];

	const randomImage = images[Math.floor(Math.random() * images.length)];

	return (
		<div className="pagebody">
			<div className="bannerImageSpace">
				<LazyLoadImage
					src={randomImage}
					alt="banner"
					className="bannerImgSize"
					effect="blur"
				/>

				<div className="overlayText">Velkomin í Atlas Endurhæfingu</div>
			</div>
			<div className="infoSpace">
				<nav className="info_navigation">
					<Link to="/umokkur/stadsetning" className="infoFlex">
						<img className="infoIcon" src={Time} alt="" />
						<div className="infoText">
							<h3>Opnunartími</h3>
							<p className="infoTextDescription">
								Mánudaga - fimmtudaga: 8:00 - 16:30
								<br />
								Föstudaga: 8:00 - 16:00
							</p>
						</div>
					</Link>

					<Link to="/timabokun" className="infoFlex">
						<img className="infoIcon" src={Calendar} alt="" />
						<div className="infoText">
							<h3>Tímabókun</h3>
							<p className="infoTextDescription">
								Óska eftir tíma hjá sjúkraþjálfara
							</p>
						</div>
					</Link>

					<Link to="/afbokun" className="infoFlex">
						<img className="infoIcon" src={Message} alt="" />
						<div className="infoText">
							<h3>Afbókun</h3>
							<p className="infoTextDescription">Afboða bókaðan tíma</p>
						</div>
					</Link>

					<Link to="/umokkur/stadsetning" className="infoFlex">
						<img className="infoIcon" src={Location} alt="" />
						<div className="infoText">
							<h3>Staðsetning</h3>
							<p className="infoTextDescription">
								Íþróttamiðstöðin Laugardal
								<br />
								Engjavegi 6, 104 Reykjavík
							</p>
						</div>
					</Link>
				</nav>
			</div>

			<div className="frontInfoSpace">
				<FrontPageSlider />
			</div>

			<div className="updatesSpace">
				<Link to="/frettir" className="frettirFrontPageLink">
					<h2> Fréttir og greinar </h2>
				</Link>
				<div className="news">
					<NewsSlider />
				</div>
			</div>
		</div>
	);
}

export default FrontPage;
